/**
 * Dashboard Configuration
 * Centralized configuration for dashboard
 *
 * @author Higertech Developer
 * @version 1.0.0
 */

const DashboardConfig = {
  // API Configuration
  api: {
    baseUrl: "/Home",
    endpoints: {
      // Station endpoints
      awlrLastReading: "/GetAwlrLastReading",
      agwlrLastReading: "/GetAgwlrLastReading",
      owLastReading: "/GetOwLastReading",
      arrLastReading: "/GetArrLastReading",
      awlrArrLastReading: "/GetAwlrArrLastReading",
      awsLastReading: "/GetAwsLastReading",
      vibratingWireLastReading: "/GetVibratingWireLastReading",
      flowMeterLastReading: "/GetFlowMeterLastReading",
      waterQualityLastReading: "/GetWaterQualityLastReading",

      // Summary & Monitoring
      summaryPos: "/GetSumarryPos",
      monitoringDeviceStatus: "/GetMonitoringDeviceStatus",
      monitoringAwlr: "/GetMonitoringAwlr",
      monitoringArr: "/GetMonitoringArr",

      // Map & Markers
      markers: "/Markers",
      riverFiles: "/Home/River/Files",
      riverAreas: "/RiverArea/GetAllRiverArea",
      stationTypes: "/station/type/total",

      // Chart & Graph
      grafik: "/grafik",

      penampang: "/GetDataGrafikPenampang",

      // CCTV
      cctvs: "/cctvs",

      // Marquee
      marquee: "/Marquee",

      // Well (AGWLR)
      wellConfig: "/GetAwlrSettingByDeviceId",
      wellData: "/GetAwlrMinuteReadingByDeviceIdAsync",

      // Observation Well
      owWellConfig: "/GetOwSettingByDeviceId",
      owWellData: "/GetAwlrMinuteReadingByDeviceIdAsync",
    },
  },

  // Leaflet + Mapbox Configuration
  map: {
    defaultZoom: 10,
    streetsStyle: "mapbox://styles/mapbox/streets-v11",
    satelliteStyle: "mapbox://styles/mapbox/satellite-streets-v12",
    infoWindow: {
      maxWidth: 400,
      minWidth: 280,
    },
    controls: {
      legendPosition: "bottomleft",
    },
  },

  // Chart Configuration (Highcharts)
  chart: {
    fontFamily: "Lexend",
    fontSize: "0.9em",
    animationDuration: 1000,
    zoomType: "xy",
    colors: {
      primary: "#7cb5ec",
      danger: "#ef5350",
      warning: "#ffa602",
      waspada: "#ffda4f",
      success: "#4DC27E",
      siaga1: "#ef5350",
      siaga2: "#ffa602",
      siaga3: "#ffda4f",
      normal: "#4DC27E",
    },
    lineWidth: 1,
    markerRadius: 1.5,
  },

  // Intervals (in milliseconds)
  intervals: {
    dataRefresh: 300000, // 5 minutes
    waterAnimation: 5000, // 5 seconds
    cctvCarousel: 50000, // 50 seconds
    marqueeSpeed: 4, // pixels per frame
  },

  // Animation Configuration
  animation: {
    fadeInDuration: 100,
    fadeOutDuration: 50,
    transitionDuration: 1000,
    cardAnimationClass: "animate__animated animate__fadeInLeft",
  },

  // River & Watershed Colors
  colors: {
    rivers: [
      "#e6194b",
      "#3cb44b",
      "#ffe119",
      "#4363d8",
      "#f58231",
      "#911eb4",
      "#46f0f0",
      "#f032e6",
      "#bcf60c",
      "#fabebe",
      "#008080",
      "#e6beff",
      "#9a6324",
      "#fffac8",
      "#800000",
      "#aaffc3",
      "#808000",
      "#ffd8b1",
      "#000075",
    ],
    riverStyle: {
      fillColor: "#4068D8",
      fillOpacity: 1,
      strokeColor: "#4068D8",
      strokeWeight: 2,
      strokeOpacity: 1,
    },
    watershedStyle: {
      fillOpacity: 0.2,
      strokeColor: "#fff",
      strokeWeight: 1,
      strokeOpacity: 0.5,
    },
  },

  // UI Configuration
  ui: {
    shimmerCount: 5,
    debounceDelay: 300,
    searchMinLength: 1,
    cardPaddingAdjustDelay: 100,
  },

  // Well/AGWLR Configuration
  well: {
    defaultDepth: 13000, // cm
    defaultPumpDepth: 5050, // cm
    defaultSensorDepth: 4880, // cm
    unit: "cm",
    animationInterval: 5000, // 5 seconds
    transitionDuration: 1000, // 1 second
  },
};

// Freeze config to prevent accidental modifications
Object.freeze(DashboardConfig);
Object.keys(DashboardConfig).forEach((key) => {
  if (
    typeof DashboardConfig[key] === "object" &&
    DashboardConfig[key] !== null
  ) {
    Object.freeze(DashboardConfig[key]);
  }
});
